export default __webpack_public_path__ + "static/media/iread_22_9.725d68c6.jpg";